/**
 * Função para formatar o CPF no formato ###.###.##-## ou CNPJ no formato ##.###.###/####-##.
 * @param {string} socialNumber - Número do CPF ou CNPJ.
 */

export function formatSocialNumber(socialNumber) {
  if (socialNumber.length === 11) {
    // Formata CPF (se tem 11 dígitos)
    return socialNumber.replace(
      /(\d{3})(\d{3})(\d{3})(\d{2})/g,
      '$1.$2.$3-$4',
    );
  } else {
    // Formata CNPJ (se tem 14 dígitos)
    return socialNumber.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
      '$1.$2.$3/$4-$5',
    );
  }
}
